import { Guardian } from '@xaamin/guardian';

Guardian.define('empresas.create', (user) => {
  return user.cliente?.servicios?.multi_empresa === true && user.can('empresas.crear');
});